module.exports = __webpack_public_path__ + "static/media/Icon_Info.b3f34c67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_Info.svg
// module id = 2319
// module chunks = 0